module.exports = __webpack_public_path__ + "product/design-template-download-2dc98384de583942ab5a0cc05fcf9b81.png";